'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';
import _map from 'lodash/map';

class Instagram extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            url: 'https://api.instagram.com/v1/users/self/media/recent?count=8&access_token=',
            data: []
        }
    }

    componentDidMount()
    {
        const url = this.state.url + this.props.token;
        axios.get(url)
        .then( response => {
            this.setState({
                data: response.data.data
            })

            $('.instagram_img img').load( () => {
                $('.instagram_list').masonry({
                    // options
                    itemSelector: '.instagram_item',
                    columnWidth: '.instagram_item',
                });
            });
        })
        .catch( error => {
            console.log(error.response);
        });
    }

    render ()
    {
        const { data } = this.state;

        return (
            <section className="container home_instagram">
                <h2 data-aos="fade-up" data-aos-duration="700">
                    <a href="https://www.instagram.com/dieedro_/">instagram.com/dieedro_</a>
                </h2>
                <div>
                    <ul className="instagram_list">
                        { _map( data, (item, index) => {
                            return (
                                <li key={ index } className="col-md-3 col-sm-6 col-xs-6 instagram_item">
                                    <a href={ item.link }>
                                        <img src={ item.images.standard_resolution.url } />
                                    </a>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </section>
        )
    }
}

Instagram.propTypes = {
    token: PropTypes.string.isRequired
}

export default Instagram;


// WEBPACK FOOTER //
// ./resources/assets/js/app/components/Instagram.js